module.exports = __webpack_public_path__ + "static/media/consultation.f287a313.png";